import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { Text } from '@inter-ikea-kompis/component-text';

/**
 * SheetBodyPadding component.
 */

export default class SheetBodyPadding extends KompisElement {
	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	@property({ type: Boolean })
	public bottomPadding = false;

	@property({ type: Boolean })
	public topPadding = false;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		const { spacing, breakpoint } = this.theme;
		return html`
			<style>
				:host {
					display: block;
					padding: 0 ${spacing.space150 / 16}rem;
					padding-top: ${this.topPadding ? spacing.space300 / 16 + 'rem' : 0};
					padding-bottom: ${this.bottomPadding ? spacing.space300 / 16 + 'rem' : 0};
				}
				@media screen and (max-width: ${breakpoint.medium.width / 16}rem) {
					:host {
						padding: 0 ${spacing.space150 / 16}rem;
						padding-top: ${this.topPadding ? spacing.space150 / 16 + 'rem' : 0};
						padding-bottom: ${this.bottomPadding ? spacing.space150 / 16 + 'rem' : 0};
					}
				}
				@media screen and (min-width: ${breakpoint.large.width / 16}rem) {
					:host {
						padding: 0 ${spacing.space300 / 16}rem;
						padding-bottom: ${this.bottomPadding ? spacing.space200 / 16 + 'rem' : 0};
					}
				}
			</style>
			<div>
				<slot></slot>
			</div>
		`;
	}

	public override connectedCallback(): void {
		this.customElements.define('kompis-text', Text);

		super.connectedCallback();
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-sheet-body-padding': SheetBodyPadding;
	}
}
